<template>
  <el-timeline class="timelineStyle">
    <el-timeline-item
      size="normal"
      :color="item.uname ? '#009157' : '#E4E7ED'"
      placement="top"
      :timestamp="item.updatedtime"
      v-for="(item, index) in timelineList"
      :key="index"
    >
      <div>
        {{ item.dept ? item.dept + "-" : ""
        }}{{ item.uname ? item.uname : item.operational }}
      </div>
      <div
        v-if="item.uname"
        class="timelineFunc"
        @click="showTimeLineDetail(item)"
        :style="{
          color: item.operational == '上传' ? '#909399' : '#009157',
        }"
      >
        {{ item.operational }}
      </div>
    </el-timeline-item>
    <el-dialog
      class="listDialog no-header-dialog"
      :visible.sync="dialogVisible"
      width="40%"
    >
      <div class="title">{{ item.operational }}</div>
      <div class="content">
        <div class="label">{{ item.operational }}意见：</div>
        <div class="detail">{{ item.content }}</div>
      </div>
      <div class="content" v-if="item.imgurl && item.imgurl.split('|').length">
        <div class="label">上传：</div>
        <div class="imgs">
          <el-image
            v-for="(image, i) in item.imgurl.split('|')"
            :key="i"
            style="width: 120px; height: 72px"
            :src="image + '?x-oss-process=image/resize,w_100'"
            :preview-src-list="item.imgurl.split('|')"
          ></el-image>
        </div>
      </div>
      <div class="sign">
        <div class="label">签名：</div>
        <img :src="item.signature" alt />
        <div class="uname">({{ item.uname }})</div>
      </div>
      <div class="overallCircleClose" @click="dialogVisible = false">
        <img src="../../assets/img/event/close.png" alt />
      </div>
    </el-dialog>
  </el-timeline>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      item: {},
    };
  },
  props: {
    timelineList: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    console.log(this.timelineList, "timeline");
  },
  methods: {
    showTimeLineDetail(item) {
      // console.log(item);
      this.item = item;
      if (item.operational == "重新上传" || item.operational == "上传") return;
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
.timelineFunc {
  position: absolute;
  top: 2px;
  right: 0;
  color: var(--themeColor);
  cursor: pointer;
}
.listDialog {
  margin: 0 20px;
  box-sizing: border-box;
  border-radius: 4px;

  .title {
    height: 60px;
    line-height: 60px;
    color: #2c3a50;
    font-size: 16px;
    width: 100%;
    background: #f4f7f9;
    box-sizing: border-box;
    text-align: center;
    margin-bottom: 20px;
    // padding-left: 26px;
    img {
      vertical-align: middle;
      margin: -4px 10px 0 0;
    }
  }
  .content,
  .sign {
    color: #353e56;
    padding: 0 24px;
    display: flex;
    .label {
      width: 150px;
    }
    margin-bottom: 50px;
  }
  .elform {
    position: relative;
  }
  .el-form-item {
    display: flex;
    padding: 0 20px;
  }
  .imgs {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 30px;
  }
  .sign {
    position: relative;
    .uname {
      position: absolute;
      right: 30px;
      bottom: 0;
    }
    img {
      width: 80%;
      height: 130px;
    }
  }
}
</style>